import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { servicesReport } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import ServicesReportContent from '../../../components/Dashboard/Subscription/ServicesReportContent'
import { LanguageConsumer } from '../../../LanguageContext'


const ServicesReport = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PageTitle.ServicesReport' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={servicesReport.image}
           description={intl.formatMessage({ id: 'PageTitle.ServicesReport' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<LanguageConsumer>
                  {({ locale }) => (
                    <ServicesReportContent handleNotificationCall={handleNotificationCall} locale={locale}/>
                  )}
                </LanguageConsumer>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default ServicesReport

